import React from 'react';
import PropTypes from 'prop-types';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { dispatchAuthenticationFactorsRefresh } from 'Hooks/useRefreshEvent';
import {
  FDDialogActions, FDDialogContent, FDPrimaryActionButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const Layout = ({ onSuccess }) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <MetaControlField attr={'primaryText'} />
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Continue'}
          fullWidth
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Sms: Dismiss success');
            dispatchAuthenticationFactorsRefresh();
            onSuccess();
          }}
          test={'security-settings-button-sms-registration-modal-continue'}
        />
      </FDDialogActions>
    </>
  );
};

Layout.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default Layout;
